import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Iconify from "src/components/iconify";

import { _mock } from "src/_mock";
import { t } from "i18next";

import AuthLoginLayout from "src/layouts/auth/login";
import IconButton from "@mui/material/IconButton";
import { JwtLoginView } from "src/sections/auth/custom";
import { useAuthContext } from "src/auth/hooks";
import { useState } from "react";
import LoginButton from "../login-button/login-button";
// ----------------------------------------------------------------------

export default function LoginDialog() {
  const { authenticated } = useAuthContext();
  const [open, setOpen] = useState(false);

  if (authenticated) return null;

  return (
    <>
      <LoginButton onClick={() => setOpen(true)} />

      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        scroll="body"
        keepMounted={false}
        disableRestoreFocus
      >
        <AuthLoginLayout>
          <DialogTitle>{t("login")}</DialogTitle>

          <IconButton
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              m: 1,
              color: "black",
            }}
            edge="end"
            onClick={() => setOpen(false)}
          >
            <Iconify icon="mingcute:close-line" />
          </IconButton>

          <DialogContent sx={{ background: "white" }}>
            <JwtLoginView onClose={() => setOpen(false)} />
          </DialogContent>
        </AuthLoginLayout>
      </Dialog>
    </>
  );
}
